<template>
  <div class="change-password">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h6 class="text-dark text-semibold">Mudar senha</h6>

      <div class="d-flex justify-content-lg-end gap-3">
        <snow-button
          size="sm"
          variant="gray"
          text="Cancelar"
          @click="resetForm"
        />
        <snow-button
          text="Salvar"
          size="sm"
          :disabled="!isValid"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 mb-lg-0 mb-4">
        <snow-input
          v-model="form.oldPassword"
          type="password"
          label="Senha atual"
        />
      </div>
      <div class="col-lg-4 mb-lg-0 mb-4">
        <snow-input
          v-model="form.newPassword"
          type="password"
          label="Nova senha"
          @blur="checkPassword"
        />
      </div>
      <div class="col-lg-4">
        <snow-input
          ref="change-password"
          v-model="form.confirmPassword"
          type="password"
          label="Confirmar senha"
          :rules="rules.confirmPassword"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SnowInput from "@/components/snow-ui/form/SnowInput.vue";
import SnowButton from "@/components/snow-ui/SnowButton.vue";

import { formFields } from "@/functions/helpers";

import { match } from "@/functions/validation";
export default {
  components: { SnowInput, SnowButton },
  data() {
    return {
      ...formFields(["oldPassword", "newPassword", "confirmPassword"])
    };
  },
  computed: {
    isValid() {
      return (
        this.form.oldPassword &&
        this.form.newPassword &&
        this.form.confirmPassword
      );
    },
    rules() {
      return {
        confirmPassword: [
          match("As senhas não coincidem", this.form.newPassword)
        ]
      };
    }
  },
  methods: {
    submit() {
      this.loading = true;
      let data = { ...this.form };
      delete data.confirmPassword;
      this.$store
        .dispatch("user/updatePassword", data)
        .then(() => {
          this.$message.success("Senha alterada com sucesso");
          this.resetForm();
        })
        .catch(e => {
          const msg = e.response.data?.message[0] || "Erro ao alterar senha";
          this.$message.error(msg);
        })
        .finally(() => (this.loading = false));
    },
    checkPassword() {
      if (this.form.newPassword && this.form.confirmPassword) {
        this.$refs["change-password"].validate();
      }
    },

    resetForm() {
      this.form.oldPassword = "";
      this.form.newPassword = "";
      this.form.confirmPassword = "";
    }
  }
};
</script>
